<template>
    <!-- 由于对话框渲染后显示在屏中间，且模式对话框时遮罩层挡住了所有操作，所以设计时使用一个div模拟，实际运行时才使用对话框 -->
    <div class="tw-dialog" v-if="designMode">
        <slot></slot>
    </div>
    <Dialog v-else :header="caption" v-model:visible="display" :modal="modal" @hide="onHide">
        <slot></slot>

        <template #footer>
            <Button label="取消" icon="pi pi-times" @click="onCancel" class="p-button-text"/>
            <Button label="确定" icon="pi pi-check" @click="onConfirm" autofocus />
        </template>
    </Dialog>
</template>

<script>
import { ref } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import messageServer from '../../services/message.service'

export default {
    name: 'tw-dialog',
    components: {
        Dialog,
        Button
    },
    emits: {
        clickCancel: null,
        clickConfirm: null
    },
    props: {
        caption: String,
        validate: { type: Function },
        modal: {
            type: Boolean,
            default: true
        }
    },
    setup(props, context) {
        const designMode = window.site && window.site.designMode;
        let result = 'clickCancel'
        let display = ref(true)

        const onCancel = function() {
            result = 'clickCancel'
            display.value = false
        }

        const onConfirm = function() {
            if (props.validate) {
                // 存在校验函数时，校验通过则触发确定事件并关闭对话框，否则不关闭
                const validateResult = props.validate()
                if (typeof validateResult === 'boolean') {
                    if (validateResult) {
                        result = 'clickConfirm'
                        display.value = false
                    }
                } else {
                    validateResult.then(() => {
                        result = 'clickConfirm'
                        display.value = false
                    }).catch(err => {
                        // 错误提示
                        if (err) {
                            messageServer.error(err.message ?? err)
                        }
                    })
                }
            } else {
                // 不存在校验函数时直接触发确定事件并关闭对话框
                result = 'clickConfirm'
                display.value = false
            }
        }

        const onHide = function() {
            context.emit(result)
        }

        return {
            designMode,
            display,
            onCancel,
            onConfirm,
            onHide
        }
    }
}
</script>

<style>

</style>